var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-row",
            { staticClass: "marginTop" },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: { label: "Tipo de cadastro:", content: _vm.tipo }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Data de cadastro:",
                      content: this.dataCadastro
                    }
                  })
                ],
                1
              ),
              _vm.dataRetificacao
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Data de retificação:",
                          content: this.dataRetificacao
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [_c("app-divider", { attrs: { label: "Qualificação" } })],
        1
      ),
      _c(
        "el-row",
        { staticClass: "margemTop" },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "div",
              { staticClass: "margem" },
              [
                _c("app-display", {
                  class:
                    _vm.compararQualificacaoCertidao &&
                    _vm.compararQualificacaoCertidao.mudouBeneficiarioOriginario
                      ? "text"
                      : "",
                  attrs: {
                    label: "É beneficiário originário?",
                    content: _vm.qualificacao.beneficiarioOriginario
                      ? "Sim"
                      : "Não"
                  }
                }),
                _c("app-display", {
                  class:
                    _vm.compararQualificacaoCertidao &&
                    _vm.compararQualificacaoCertidao.mudouAreaGeorreferenciada
                      ? "text"
                      : "",
                  attrs: {
                    label:
                      "A área é georreferenciada tendo sido o Título emitido de acordo com a Lei 10.267/01? ",
                    content: _vm.qualificacao.areaGeorreferenciada
                      ? "Sim"
                      : "Não"
                  }
                }),
                _c("app-display", {
                  class:
                    _vm.compararQualificacaoCertidao &&
                    _vm.compararQualificacaoCertidao.mudouAreaMatriculada
                      ? "text"
                      : "",
                  attrs: {
                    label: "A área está matriculada?",
                    content: _vm.qualificacao.areaMatriculada ? "Sim" : "Não"
                  }
                }),
                _c(
                  "span",
                  { staticClass: "pessoas" },
                  [
                    _vm._v("Lista de pessoas que acompanham o processo"),
                    _vm._l(_vm.pessoas, function(pessoa, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "viewPersonInfo" },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v(_vm._s(pessoa.nomeRazaoSocial))
                          ]),
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(
                                pessoa.documento ? pessoa.documento.nome : ""
                              )
                            )
                          ]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: "Baixar arquivo",
                                placement: "top"
                              }
                            },
                            [
                              pessoa.documento
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "buttonDocument",
                                      on: {
                                        click: function($event) {
                                          return _vm.getDownload(
                                            pessoa.documento
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "download", size: "lg" }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4489489e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4489489e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesQualificacaoCertidao.vue
// module id = null
// module chunks = 